import { Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const ActionButton = ({ link }) => {
  return (
    <>
      <div className="flex-container justify-center">
        <Link to={link} target="_blank" style={{ textDecoration: 'none', color: 'inherit' }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{ textTransform: 'none', margin: '20px', minWidth: '180px' }}>
            Let&apos;s Go
          </Button>
        </Link>
      </div>
    </>
  );
};

export default ActionButton;
